// extracted by mini-css-extract-plugin
module.exports = {"swatch":"swatch__12hEU","colorRow":"colorRow__3Vzob","colorRowInvalid":"colorRowInvalid__2CFM5","colorField":"colorField__1RX2u"};